module.exports = __webpack_public_path__ + "img/icon-flecha.43587b5f.svg";